// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PurePathSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PurePathSignetIcon" ref={forwardedRef} {...props}>
      <path d="M12.122 9.627 5.845 16.22a.276.276 0 0 0 .01.386A.27.27 0 0 0 6 16.675a48 48 0 0 0 2.132.287c1.212.14 2.856.252 3.092.27.019 0 .181.016.252.016.048 0 .543.059 1.008-.387.74-.705 2.261-2.167 3.255-3.12a.404.404 0 0 0 .022-.565l-.022-.022z" />
      <path d="M3 8.525a60 60 0 0 0 .114 3.14 44 44 0 0 0 .137 1.633.275.275 0 0 0 .296.245.26.26 0 0 0 .152-.067l7.504-6.621.983-.865.824.898 3.753 4.057a.135.135 0 0 0 .193.007A.14.14 0 0 0 17 10.848a56 56 0 0 0-.107-2.282c-.148-2.168-.414-4.08-.414-4.08V4.48a.69.69 0 0 0-.536-.572h-.007s-1.888-.36-4.03-.612a61 61 0 0 0-3.337-.293c-.048 0-.543-.06-1.016.382l-4.12 3.93C2.968 7.765 3 8.265 3 8.307z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PurePathSignetIcon = /* @__PURE__ */ Object.assign(
  PurePathSignetIconComponent,
  { displayName: 'PurePathSignetIcon' },
);
